module.exports = __webpack_public_path__ + "img/seminar4.ffa19b74.jpg";